import { render, staticRenderFns } from "./EmpresaNuevo.vue?vue&type=template&id=d6c34dec"
import script from "./EmpresaNuevo.vue?vue&type=script&lang=js"
export * from "./EmpresaNuevo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports